(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["rv-indice-circolare"] && !Shopify.designMode) return;
  try {
    class RvCircularIndex extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      if (!this.tabs.length) return;
      // -1 = nessuna parte aperta, cioe' al centro c'e' la copertina.
      // E' lo stato di riposo, non uno stato iniziale: ci si torna
      // ricliccando la pastiglia gia' aperta.
      this.aperta = -1;
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeyDown);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeyDown);
    }

    onClick = (event) => {
      const tab = event.target.closest('[role="tab"]');
      if (!tab) return;
      const index = this.tabs.indexOf(tab);
      this.apri(this.aperta === index ? -1 : index);
      this.select(index);
    };

    onKeyDown = (event) => {
      if (!event.target.closest('[role="tab"]')) return;
      const current = this.tabs.indexOf(event.target.closest('[role="tab"]'));
      const last = this.tabs.length - 1;
      let next = null;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = current === last ? 0 : current + 1;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = current === 0 ? last : current - 1;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = last;
      if (next === null) return;
      event.preventDefault();
      this.select(next);
      // Le frecce spostano la selezione, non aprono e non chiudono:
      // se l'immagine e' gia' aperta segue la parte selezionata, se
      // e' chiusa resta la copertina.
      if (this.aperta > -1) this.apri(next);
      this.tabs[next].focus();
    };

    // Pilota SOLO l'immagine al centro. Il pattern tab, il roving
    // tabindex e il pannello dei capitoli restano quelli di prima.
    apri(index) {
      this.aperta = index;
      if (index < 0) this.removeAttribute('data-aperta');
      else this.dataset.aperta = String(index + 1);
    }

    select(index) {
      if (index < 0) return;
      this.tabs.forEach((tab, i) => {
        const active = i === index;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach((panel, i) => {
        panel.dataset.active = i === index ? 'true' : 'false';
      });
    }
  }

  if (!customElements.get('rv-circular-index')) {
    customElements.define('rv-circular-index', RvCircularIndex);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["rv-sfoglia-dentro"] && !Shopify.designMode) return;
  try {
    /* Unico JS del blocco, e serve solo all'autoscroll: ventaglio, snap,
     inclinazioni e barretta sono tutti CSS. Quattro guardie: desktop,
     reduced motion, editor del tema, e il tocco dell'utente, che ferma
     tutto per sempre. */
  class RvSfogliaDeck extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.rv-sf__fan');
      const vale = (q) => matchMedia(q).matches;
      if (!this.track || (window.Shopify && window.Shopify.designMode)) return;
      if (vale('(min-width: 1120px)') || vale('(prefers-reduced-motion: reduce)')) return;
      const ferma = () => { this.stopped = true; this.pulisci(); };
      ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach((e) =>
        this.track.addEventListener(e, ferma, { once: true, passive: true }));
      this.observer = new IntersectionObserver(([voce]) => {
        if (!this.stopped) voce.isIntersecting ? this.start() : clearInterval(this.timer);
      }, { threshold: 0.4 });
      this.observer.observe(this.track);
    }

    start() {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        const pagina = this.track.querySelector('.rv-sf__page');
        if (!pagina) return;
        const passo = pagina.offsetWidth + (parseFloat(getComputedStyle(this.track).columnGap) || 0);
        const massimo = this.track.scrollWidth - this.track.clientWidth;
        const left = this.track.scrollLeft + passo > massimo - 4 ? 0 : this.track.scrollLeft + passo;
        this.track.scrollTo({ left, behavior: 'smooth' });
      }, 4000);
    }

    pulisci() { clearInterval(this.timer); if (this.observer) this.observer.disconnect(); }

    disconnectedCallback() { this.pulisci(); }
  }

  if (!customElements.get('rv-sfoglia-deck')) customElements.define('rv-sfoglia-deck', RvSfogliaDeck);
  } catch(e) { console.error(e); }
})();

})();
